import React from 'react';
import ImageSearch from './components/ImageSearch';

function App() {
  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
      <h1> StyleU: Visual Search</h1>
      <ImageSearch />
    </div>
  );
}

export default App;
